import { render, staticRenderFns } from "./productivity.vue?vue&type=template&id=35b92d88&"
import script from "./productivity.vue?vue&type=script&lang=js&"
export * from "./productivity.vue?vue&type=script&lang=js&"
import style0 from "./productivity.vue?vue&type=style&index=0&id=35b92d88&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b92d88')) {
      api.createRecord('35b92d88', component.options)
    } else {
      api.reload('35b92d88', component.options)
    }
    module.hot.accept("./productivity.vue?vue&type=template&id=35b92d88&", function () {
      api.rerender('35b92d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/productivity.vue"
export default component.exports